module.exports = __webpack_public_path__ + "static/media/electric1.6083e80b.png";